import { Inject, Injectable } from '@angular/core';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createRefreshHandler } from './../../../../utils';
import { WchLoggerService } from './../../logger/wch.logger.service';
import { RefreshService } from './../../refresh/refresh.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkRefreshHandler';

/**
 * Executes a refresh event
 */
@Injectable()
export class SdkRefreshHandler implements SdkMessageHandler {

    handle: SdkMessageHandlerCallback;

    constructor(
        @Inject(RefreshService) refreshService: RefreshService,
        @Inject(WchLoggerService) loggerService: WchLoggerService) {
        // create the handler
        this.handle = createRefreshHandler(() => refreshService.refresh(), loggerService.get(LOGGER));
    }

}

